import { getApiBaseUrl } from '../../utils/apiConfig';

export async function fetchPassPolicy() {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${getApiBaseUrl()}/api/security/pass-policy`, {
    headers: { Authorization: token ? `Bearer ${token}` : '' },
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Erro ao carregar política de senha');
  return json.data;
}

export async function savePassPolicy(data) {
  const token = localStorage.getItem('authToken');
  const res = await fetch(`${getApiBaseUrl()}/api/security/pass-policy`, {
    method: 'POST',
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Erro ao salvar');
  return json;
}
